export const DefaultLang = 'vi';
